import React from 'react';
import './style.css';

const Pagination = ({ page, size, totalRecords, rowSize, itensOnCurrentPage, pageChange }) => {
    const pageNumbers = [];
    const pagesShowing = [];
    const rowsSize = [];

    rowsSize.push(25);
    rowsSize.push(50);
    rowsSize.push(100);

    for (let i = 1; i <= Math.ceil(totalRecords / size); i++) {
        pageNumbers.push(i);
    }

    for (var j = 0; j < pageNumbers.length; j++){
        var numberPlus = page === 1 ? 4 : page === 2 ? 3 : 2;
        var numberMinus = page === pageNumbers.length ? 4 : page === pageNumbers.length - 1 ? 3 : 2;
        if (pageNumbers[j] >= page - numberMinus && pageNumbers[j] <= page + numberPlus) {
            pagesShowing.push(pageNumbers[j])
        }
    }

    function handleItemsOnCurrentPageChange(e){
        const { value } = e.target;
        pageChange(1, Number(value));
    }

    return (
        <div className="paginator-container">
            <nav style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 20, marginRight: 70}}>

                <ul style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginBottom: 0}}>
                {page > 1  && (
                    <>
                        <button className="buttonStyle" onClick={() => pageChange(1)} > <i className="fas fa-angle-double-left"></i></button>
                        <button className="buttonStyle" onClick={() => pageChange(page - 1)} > <i className="fas fa-angle-left"></i></button>
                    </>
                )}
                    {pagesShowing.map(number => (
                        <button onClick={() => pageChange(number)} className={'page-link' + (number === page ? 'active' : '') }>
                            {number}
                        </button>
                    ))}
                    {page <= totalRecords / rowSize && (
                        <>
                            <button className="buttonStyle" onClick={() => pageChange(page + 1)} ><i className="fas fa-angle-right"></i></button>
                            <button className="buttonStyle" onClick={() => pageChange(pageNumbers.length)}><i className="fas fa-angle-double-right"></i></button>
                        </>
                        )
                    }
                </ul>
                <div className="count">
                    <select className="select-rows" value={itensOnCurrentPage} onChange={(e) => handleItemsOnCurrentPageChange(e)}>
                        { rowsSize.map(item => (
                            <option key={item} value={item}>{item}</option>
                        ))}
                    </select>
                </div>
                <div className="count">
                    Total: {totalRecords}
                </div>
            </nav>
        </div>
    );
}

export default Pagination;
